import { EndPageContent } from './EndPageContent'
import { EndPageDrawer } from './EndPageDrawer'

export const EndPageTab = (): JSX.Element => {
  return (
    <>
      <EndPageDrawer />
      <EndPageContent />
    </>
  )
}
